import { FC, useMemo } from 'react';

import { ServiceOfferItem } from '../../../model';
import { DetailsModal } from '../../PlanCard';
import { transformServiceOffersToPlanCardDetails } from './PlanCardUtils';

type Props = {
    items: ServiceOfferItem[];
};

export const PlansDetailsModal: FC<Props> = ({ items }) => {
    const details = useMemo(() => transformServiceOffersToPlanCardDetails(items), [items]);

    return <DetailsModal details={details} />;
};
